import React from 'react'
import TopHeader from '../home/TopHeader'
import Breadcrumbs from '../common/Breadcrumbs'
import Footer from '../home/Footer'

export default function AboutUs() {
    return (
        <div>
            <TopHeader />
            <Breadcrumbs main={"About Us"} parent={"About Us"} />
            <div className='container'>
                <h4>About US</h4>
                <p className="mb-16">
                    HN Store is built with a clear vision to provide customers with access to quality products through a reliable and transparent online platform. We believe that online shopping should be simple, secure, and trustworthy for every customer. Our focus is on delivering value by maintaining high standards in product selection and service delivery.
                </p>
                <p className="mb-16">
                    We carefully curate our product offerings to ensure quality, authenticity, and usability. Each product available on HN Store is sourced from verified suppliers and evaluated to meet customer expectations. Transparency in pricing and operations remains one of our core principles, helping us build long-term trust with our customers.
                </p>
                {/* <p className="mb-16">

                    HN Store is owned and operated by Nishit Chandubhai Kachiya (HUF) and functions as a legally compliant business entity. The business is officially registered at C-602, Aradhna Residency, Gangotri Circle, Nikol, Ahmedabad, Gujarat. 382350 and operates in accordance with applicable Indian laws and regulations.
                    We maintain proper documentation, statutory registrations, and compliance standards required for e-commerce operations in India.
                </p> */}
                {/* <p className="mb-16">

                    HN Store is owned and operated by Nishit Chandubhai Kachiya  and functions as a legally compliant business entity named ICODE49 TECHNOLABS. We maintain proper documentation, statutory registrations, and compliance standards required for e-commerce operations in India.
                </p> */}
                <p className="mb-16">
                    Our platform is designed to provide a smooth and secure shopping experience. We prioritize data protection, user privacy, and secure payment processing. All transactions are handled through trusted payment partners to ensure safety and reliability for our customers.
                </p>
                <p className="mb-16">
                    Customer satisfaction is central to our operations. We aim to process orders efficiently and ensure timely delivery through reliable logistics partners. Our support team is available to assist customers with queries, concerns, or order-related assistance, ensuring a responsive and responsible service approach.
                </p>
                <p className="mb-16">
                    HN Store follows ethical business practices and maintains accountability in all aspects of operations. We actively monitor feedback and continuously improve our processes to better serve our customers. Our goal is not just to complete transactions, but to build lasting relationships based on trust and service quality.
                </p>


            </div>
            <Footer />
        </div>
    )
}
